<template>
    <div id="article-progress">
        <iframe
            ref="iframe"
            :src="siteUrl"
            @load="iframeLoaded"
            frameborder="0"
            width="100%"
            style="height: 100vh"
        ></iframe>
    </div>
</template>

<script>
export default {
    // 稿件进度
    name: "articleprogress",
    data() {
        return {
            // 跳转采编名片稿件查询
            siteUrl: "",
            targetOrigin: "",
        };
    },
    created() {
        // 跳转采编 地址，区分环境

        if (location.host.indexOf("test.") != -1) {
            // 采编测试地址
            this.targetOrigin = "https://cbtest.cnknowledge.com"; // 测试环境
        } else if (location.host.indexOf("yu.") != -1) {
            this.targetOrigin = "https://yucard.cnknowledge.com"; // 预发布环境
        } else if (
            location.host.indexOf("localhost") != -1 ||
            location.host.indexOf("127.") != -1
        ) {
            this.targetOrigin = "http://localhost:8081"; // 本地
        } else {
            this.targetOrigin = "https://card.cnknowledge.com"; // 正式环境
        }
        this.siteUrl = this.targetOrigin + "/progressList?back=true&fromzw=true";
    },
    mounted() {
        window.addEventListener("message", this.handleMessage);
    },
    methods: {
        // 监听子页面传过来的值的方法  @param {Object} event
        handleMessage(event) {
            console.log(event);
            var origin = event.origin || event.originalEvent.origin;

            if (origin == this.targetOrigin) {
                if (event.data == "back") {
                    // 返回首页或学者页
                    let backPath =
                        this.$route.query.fromHome == "true" ? "/index" : "/scholar-service";
                    this.$router.push({ path: backPath });
                } else if (event.data == "login") {
                    // token过期，跳转登录页
                    this.$router.push("/logins");
                }
            }
        },
        iframeLoaded() {
            let token = sessionStorage.getItem("token");
            this.$refs.iframe.contentWindow.postMessage(token, this.targetOrigin);
        },
    },
    beforeDestroy() {
        window.removeEventListener("message", this.handleMessage);
    },
    destroyed() {},
};
</script>

<style></style>
